__turbopack_context__.v({
  "button": "Button-module__Rmgt5G__button",
  "dark": "Button-module__Rmgt5G__dark",
  "large": "Button-module__Rmgt5G__large",
  "link": "Button-module__Rmgt5G__link",
  "medium": "Button-module__Rmgt5G__medium",
  "outline": "Button-module__Rmgt5G__outline",
  "primary": "Button-module__Rmgt5G__primary",
  "secondary": "Button-module__Rmgt5G__secondary",
  "small": "Button-module__Rmgt5G__small",
});
